import initstate from "./state";
const user = (state = initstate, action) => {
  switch (action.type) {
    case 'SET_USER_INFO':
		return {
			...state,
			...action.user
		}
	case 'SET_REFRESHSTATUS':
			state.refreshStatus = action.status
			return {
				...state
			}
	case  'SET_ACCESSTOKEN':
		state.accessToken = action.accessToken
		return {
			...state
		}
	case 'SET_EXPIRES':
		state.expires = action.expires
		return {
			...state
		}
	case 'SET_THEME':
		state.theme = action.data
		return {
			...state
		}
	case 'SET_APP_INFO':
		state.app = action.data
		return {
			...state,
			...action.app
		}
    default:
      return state
  }
}

export default user


// WEBPACK FOOTER //
// ./src/redux/user.js